<p-confirmDialog key="parent" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div>
	<!--Heading-->
	<div>
		<!--Info-->
		<div>
			<h4><strong>Facility:</strong> {{ FacilityName }}</h4>
			<h4 *ngIf="Init == true && FacilityLocationID > 0"><strong>Location:</strong> {{ FacilityLocationName }}</h4>
			<h4><strong>Scan Type:</strong> {{ TimeScanTypeDesc }}</h4>
		</div>

		<!--View-->
		<div class="ViewGrid">
			<label>View:</label>
			<div class="RadioGrid">
				<input
					id="All"
					value="All"
					name="ViewOption"
					[(ngModel)]="ViewOption"
					(ngModelChange)="onViewOptionChange($event)"
					type="radio"
					class="CHK"
					[disabled]="IsLoading() == true"
				/>
				<label for="All">All</label>

				<input
					id="Scanned"
					value="Scanned"
					name="ViewOption"
					[(ngModel)]="ViewOption"
					(ngModelChange)="onViewOptionChange($event)"
					type="radio"
					class="CHK LeftMargin"
					[disabled]="IsLoading() == true"
				/>
				<label for="Scanned">Scanned</label>

				<input
					id="Manual"
					value="Manual"
					name="ViewOption"
					[(ngModel)]="ViewOption"
					(ngModelChange)="onViewOptionChange($event)"
					type="radio"
					class="CHK LeftMargin"
					[disabled]="IsLoading() == true"
				/>
				<label for="Manual">Manual</label>
			</div>
			<label>Item Count: {{ lstSelectedScans.length }}</label>
		</div>
	</div>

	<!--Main Content-->
	<div class="MainContent">
		<!--Main Area-->
		<div [style.Width]="ShowManual == false && ShowSettings == false ? '100%' : '70%'">
			<caass-time-scan-main-area [lstScans]="lstSelectedScans"> </caass-time-scan-main-area>

			<!--Buttons-->
			<div class="MainButtons">
				<button class="btn btn-primary" [disabled]="IsLoading() == true" (click)="onClear()">Clear</button>
				<button class="btn btn-primary SmallLeftMargin" [disabled]="IsLoading() == true" (click)="onSettings()">Settings</button>
				<button class="btn btn-primary SmallLeftMargin" [disabled]="IsLoading() == true" (click)="onManual()">Manual</button>
			</div>
		</div>

		<!--Side Bars-->
		<div [style.Width]="ShowManual == false && ShowSettings == false ? '0%' : '30%'">
			<caass-time-scan-manual-bar
				*ngIf="ShowManual == true"
				[FacilityID]="FacilityID"
				[FacilityLocationID]="FacilityLocationID"
				[TimeScanTypeID]="TimeScanTypeID"
				[TimeScanTypeDesc]="TimeScanTypeDesc"
				[Receipt_IDPrinterID]="Receipt_IDPrinterID"
				(ManualScan)="onManualScan($event)"
				(CloseManual)="onManual()"
			>
			</caass-time-scan-manual-bar>

			<caass-time-scan-settings-bar
				*ngIf="ShowSettings == true"
				[TimeScanTypeID]="TimeScanTypeID"
				[lstTimeScanType]="lstTimeScanType"
				(UpdateType)="onUpdateType($event)"
				(CloseSettings)="onSettings()"
			>
			</caass-time-scan-settings-bar>
		</div>
	</div>
</div>
